// 处理主题样式
export function handleThemeStyle(theme) {
  document.documentElement.style.setProperty('--el-color-primary', theme)
  for (let i = 1; i <= 9; i++) {
    document.documentElement.style.setProperty(`--el-color-primary-light-${i}`, `${getLightColor(theme, i / 10)}`)
  }
  for (let i = 1; i <= 9; i++) {
    document.documentElement.style.setProperty(`--el-color-primary-dark-${i}`, `${getDarkColor(theme, i / 10)}`)
  }

  // AntD v5-like tokens for color system
  document.documentElement.style.setProperty('--color-primary', theme)
  // derive common shades (approximate scale)
  document.documentElement.style.setProperty('--color-primary-50', getLightColor(theme, 0.9))
  document.documentElement.style.setProperty('--color-primary-100', getLightColor(theme, 0.8))
  document.documentElement.style.setProperty('--color-primary-200', getLightColor(theme, 0.7))
  document.documentElement.style.setProperty('--color-primary-300', getLightColor(theme, 0.6))
  document.documentElement.style.setProperty('--color-primary-400', getLightColor(theme, 0.3))
  document.documentElement.style.setProperty('--color-primary-500', getLightColor(theme, 0.15))
  document.documentElement.style.setProperty('--color-primary-600', theme)
  document.documentElement.style.setProperty('--color-primary-700', getDarkColor(theme, 0.12))
  document.documentElement.style.setProperty('--color-primary-800', getDarkColor(theme, 0.2))
  document.documentElement.style.setProperty('--color-primary-900', getDarkColor(theme, 0.28))
}

// hex颜色转rgb颜色
export function hexToRgb(str) {
  str = str.replace('#', '')
  let hexs = str.match(/../g)
  for (let i = 0; i < 3; i++) {
    hexs[i] = parseInt(hexs[i], 16)
  }
  return hexs
}

// rgb颜色转Hex颜色
export function rgbToHex(r, g, b) {
  let hexs = [r.toString(16), g.toString(16), b.toString(16)]
  for (let i = 0; i < 3; i++) {
    if (hexs[i].length == 1) {
      hexs[i] = `0${hexs[i]}`
    }
  }
  return `#${hexs.join('')}`
}

// 变浅颜色值
export function getLightColor(color, level) {
  let rgb = hexToRgb(color)
  for (let i = 0; i < 3; i++) {
    rgb[i] = Math.floor((255 - rgb[i]) * level + rgb[i])
  }
  return rgbToHex(rgb[0], rgb[1], rgb[2])
}

// 变深颜色值
export function getDarkColor(color, level) {
  let rgb = hexToRgb(color)
  for (let i = 0; i < 3; i++) {
    rgb[i] = Math.floor(rgb[i] * (1 - level))
  }
  return rgbToHex(rgb[0], rgb[1], rgb[2])
}
